import { PhoneIcon } from '@heroicons/react/outline';
import React from 'react';
import { useLocation } from 'react-router-dom';

export default function Navbar() {
    const location = useLocation();
    const page = location.pathname;

    return (
        <div>
            <div className='max-w-7xl p-5 mx-auto flex justify-center md:justify-between'>
                <a href="/">
                    <div className='flex items-center justify-center font-serif text-2xl text-white'>
                        <img src="/unitedtaxattorneys.png" alt="United Tax Attorneys" className='h-14' />
                    </div>
                </a>
                <div className='flex items-center justify-end gap-6'>
                    <a href={page === "/call-now" ? "tel:800-730-6512" : "tel:8449844926"} className="hidden md:flex items-center justify-center text-2xl hover:underline text-gray-900 font-semibold">
                        <PhoneIcon className='mt-2 mr-2 h-6 w-6' /> {page === "/call-now" ? "(800) 730-6512" : "(844) 984-4926"}
                    </a>
                    {/* <a href="/#start" className="hidden md:flex bg-red-700 hover:bg-red-900 text-white w-full md:w-fit text-center px-6 h-12 items-center justify-center text-xl rounded-full font-semibold">
                        Get Started Today <ArrowRightIcon className='ml-2 h-4 w-4' />
                    </a> */}
                </div>
            </div>
        </div>
    );
}
